import article from "./article";
import banner from "./banner";
import serviceCase from "./case";
import venue from "./venue";
import hotel from "./hotel";
import points from "./points";
import gift from "./gift";
export default {
    article,
    banner,
    case: serviceCase,
    venue,
    hotel,
    points,
    gift,
}
